export function PM_Image_Not_Found() {
  var pRef = this["picmgr"];
  if (pRef == null) return;

  //var picMgr = pRef.fPictureMgr;
  // picMgr.LoadSubscribers(pRef.fDirectory, pRef.fFileName, null);
  var catastrophic_failure = false;
  var src = this.src + "1";

  if (src.slice(-5) == "11111") catastrophic_failure = true;

  if (catastrophic_failure)
    this.src = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
  else this.src = src;

  //console.log("PM_Image_Not_Found - this should never happen!");
}
